import { render, staticRenderFns } from "./instituciones-registrar-f1-snp.vue?vue&type=template&id=388e9596&"
import script from "./instituciones-registrar-f1-snp.component.ts?vue&type=script&lang=ts&"
export * from "./instituciones-registrar-f1-snp.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports